export default "__VITE_ASSET__X6nS33Kt__"